<template>
  <div class="studentMessageHome">
    <div v-if="name!=='成年人'">
      <div class="navBox" >
        <div class="navRight">
          <ul style="width:350px">
            <router-link v-for="(item,index) in navRight" :key="index" tag="li" :to="item.path">{{item.name}}</router-link>
          </ul>
        </div>
      </div>
      <router-view></router-view>
    </div>
    <div v-else class="notYet">
      <div class="up_data">
        <div class="photo">
            <img src="imgs/logo/updata.png"/>
            <div class="information">成年人暂未开放该功能</div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  components:{
   
  },
  name: "index",
  data(){
    return {
      active: 0,
      navRight:[
        { name: '目标拆分', idx: '0', path: '/consultant/minestudent/main/implement/targetsplit' },
        { name: '行动计划', idx: '1', path: '/consultant/minestudent/main/implement/actionplan' },
        { name: '阶段评估', idx: '2', path: '/consultant/minestudent/main/implement/assessment' }
      ],
      query:'',
      name:null,
    }
  },
  mounted() {
    this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.chaifenNow, {
            studentId:sessionStorage.getItem("myStudentStudentId"),
          }, {
            headers: {
              token: window.sessionStorage.getItem('ymtxToken')
            }
          }).then((res) => {
            if (res.data.code == 2000) {
              // console.log(res.data.data.name)
              this.name = res.data.data.name

            }else{

            }
          })

  },
  
}
</script>


<style lang="less" scoped>
.studentMessageHome {
  .navBox {
    background-color: #fff;
    padding: 10px 30px 24px 30px;
    .navRight {
      padding: 0 25px;
      height: 55px;
      border-bottom: 1px solid rgba(217, 217, 217, 1);
      box-sizing: border-box;
      ul{
        display: flex;
        justify-content: space-between;
      }
      li {
        box-sizing: border-box;
        height: 54px;
        line-height: 54px;
        font-size: 17px;
        font-weight: 500;
        cursor: pointer;
      }

      .router-link-active {
        border-bottom: 2px solid #3D90F6;
        color: #3D90F6;
      }
    }
  }
}
.notYet{
  width: 100%;
  min-height: 500px;
  background: #fff;
}
.up_data{
    width: 100%;
    background: #fff;
    min-height: 800px;
    padding: 93px 0px;
    box-sizing: border-box;
}
.photo{
    width: 400px;
    height: 200px;
    margin: 0 auto;  
    text-align: center;
}
.information{
    font-size: 26px;
    line-height: 56px;
    text-align: center;
}
</style>